import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3v18h18","key":"svg-0"}],["path",{"d":"M7 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M17 7a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M12 15a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M10.16 10.62l2.34 2.88","key":"svg-4"}],["path",{"d":"M15.088 13.328l2.837 -4.586","key":"svg-5"}]]

const IconChartDots = createReactComponent('outline', 'chart-dots', 'ChartDots', __iconNode);

export default IconChartDots;